// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"fe5a98e1","344":"d7e33f31","724":"88872d8d","900":"7674cd0c"}[chunkId] + ".chunk.js";
};